const zhuokao = {
  detail: [
    require('assets/img/app/1.png'),
    require('assets/img/app/2.png'),
    require('assets/img/app/3.png'),
    require('assets/img/app/4.png'),
  ],
  androidUrl: 'http://resource.zhuokao360.com/app/zkwx-release.apk',
  iosUrl: 'https://apps.apple.com/cn/app/id1479497993',
};

const jmdc = {
  detail: [
    require('assets/img/app/jmdc/1.png'),
    require('assets/img/app/jmdc/2.png'),
    require('assets/img/app/jmdc/3.png'),
    require('assets/img/app/jmdc/4.png'),
  ],
  androidUrl: 'http://resource.zhuokao360.com/app/jmdc-release.apk',
  iosUrl: 'https://apps.apple.com/cn/app/id1490401573',
};

const btzx = {
  detail: [
    require('assets/img/app/btzx/1.png'),
    require('assets/img/app/btzx/2.png'),
    require('assets/img/app/btzx/3.png'),
  ],
  androidUrl: 'http://resource.zhuokao360.com/app/btzx-release.apk',
  iosUrl: 'https://apps.apple.com/cn/app/id1518906422',
};

const xskt = {
  detail: [
    require('assets/img/app/xskt/1.png'),
    require('assets/img/app/xskt/2.png'),
    require('assets/img/app/xskt/3.png'),
  ],
  androidUrl: 'http://resource.zhuokao360.com/app/xskt-release.apk',
  iosUrl: 'https://apps.apple.com/cn/app/id1570789127',
};

const bt = {
  detail: [
    require('assets/img/app/bt/1.png'),
    require('assets/img/app/bt/2.png'),
    require('assets/img/app/bt/3.png'),
  ],
  androidUrl: 'http://resource.zhuokao360.com/app/bt-v1_0_0.apk',
  iosUrl: '',
};

export {
  zhuokao,
  jmdc,
  btzx,
  xskt,
  bt,
};
